import { alpha, Box, Container } from "@mui/material";
import React from 'react';
import { Slide, Typography, useMediaQuery, useTheme } from "@mui/material";
import ImageBackground from "../../../utility/component/ImageBackground";

const EcoSystemSection = ({image, list}) => {
  const theme = useTheme();
  const bp = theme.breakpoints;
  const upBp = useMediaQuery(bp.up("md"));

  return (
    <Container sx={{ overflowX: "hidden" }}>
      <ImageBackground
        image={image}
        center='center'
        sx={{
          float: upBp ? "left" : "none",
          shapeOutside: "polygon(0 0, 75% 10%, 100% 50%, 70% 90%, 0 100%)",
          width: upBp ? 600 : "100%",
          maxWidth: 600,
          height: upBp ? 600 : 320,
          mb: upBp ? 0 : 3,
          mr: upBp ? 6 : 0,
        }}/>
      {list?.map((item, i) => (
        <Slide key={i} direction="left" in={true} timeout={500 + 100 * i}>
          <Box className='flex flex-col justify-center flex-1' p={upBp ? 2 : 0} minWidth={250 - i * 50}>
            <Typography
              variant={upBp ? "h3" : "h4"}
              sx={{ fontWeight: theme.typography.fontWeightMedium }}
            >
              {item.title}
            </Typography>
            <Typography
              variant={upBp ? "h6" : "body1"}
              sx={{
                mt: 3,
                mb: 3,
                color: alpha(theme.palette.primary.contrastText, 0.72),
                fontWeight: theme.typography.fontWeightRegular,
              }}
            >
              {item.description}
            </Typography>
          </Box>
        </Slide>
      ))}
      <Box sx={{ clear: "both" }} />
    </Container>
  );
};

export default EcoSystemSection;
